import { render, staticRenderFns } from "./SOPStandard.vue?vue&type=template&id=bcc1851e&scoped=true&"
import script from "./SOPStandard.vue?vue&type=script&lang=js&"
export * from "./SOPStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc1851e",
  null
  
)

export default component.exports